export default __webpack_public_path__ + "static/media/a011-fsi-01.7f1e8871.svg";